







































import { Vue, Component } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbBtn, mdbTooltip } from '@folky-tools/mdbvue';
import BusinessProductDeliverySummary from '@/components/businesses/BusinessProductDeliverySummary.vue';
import BusinessProductSellingStatusSummary from '@/components/businesses/BusinessProductSellingStatusSummary.vue';
import BusinessProductOrderingHoursSummary from '@/components/businesses/BusinessProductOrderingHoursSummary.vue';
import { Business } from '@/models/businesses/business';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';
import { businessesService, businessFrontPagesService, businessSellingOptionsService } from '@/services';

@Component({
    components: {
        BusinessProductDeliverySummary,
        BusinessProductSellingStatusSummary,
        BusinessProductOrderingHoursSummary,
        mdbRow,
        mdbCol,
        mdbBtn,
        mdbTooltip,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessSellingView extends Vue {
    private business: Business = new Business();
    private businessFrontPage: BusinessFrontPage = new BusinessFrontPage();
    private businessSellingOptions: BusinessSellingOptions = new BusinessSellingOptions();
    private pageContentLoaded: boolean = false;

    private async created(): Promise<void> {
        this.business = await businessesService.getBusiness(+this.$route.params.id);
        this.businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
        this.businessSellingOptions = await businessSellingOptionsService.getSellingOptions(+this.$route.params.id);
        this.pageContentLoaded = true;
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessSellingView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');
    }
}
